import React, { createContext, useContext, ReactNode } from 'react';
import { usePriceCache, UsePriceCacheReturn } from '@/hooks/usePriceCache';

const PriceCacheContext = createContext<UsePriceCacheReturn | null>(null);

interface PriceCacheProviderProps {
  children: ReactNode;
}

export function PriceCacheProvider({ children }: PriceCacheProviderProps) {
  const priceCache = usePriceCache();
  
  return (
    <PriceCacheContext.Provider value={priceCache}>
      {children}
    </PriceCacheContext.Provider>
  );
}

export function usePriceCacheContext(): UsePriceCacheReturn {
  const context = useContext(PriceCacheContext);
  if (!context) {
    throw new Error('usePriceCacheContext must be used within a PriceCacheProvider');
  }
  return context;
}
